import { render, staticRenderFns } from "./ManagePackageLayout.vue?vue&type=template&id=33843bb4"
import script from "./ManagePackageLayout.vue?vue&type=script&lang=js"
export * from "./ManagePackageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports